import React from 'react';
import {IonButton, IonIcon} from '@ionic/react';
import {downloadOutline} from "ionicons/icons";
import moment from "moment-timezone";
import {callFunctionToDownload} from "../lib/downloadHelper";


export default function NewsLetterCard({post}) {
    return (
        <div className="feed-item" key={post.id}>
            <div className="feed-item-img-sec">
              <img src={post.image_url} alt={post.caption} className="feed-image"/>
            </div>
            <div className="feed-text">
                <div className="feed-text-1-div">
                    <p className="feed-caption">{moment(post.created_at).format('MMMM YYYY')}</p>
                </div>
                <IonButton onClick={()=>callFunctionToDownload(post.pdf_url)} expand="block" className="download-button">
                    <IonIcon icon={downloadOutline}/>
                </IonButton>
            </div>
        </div>
    );
}
